<template>
  <a-modal
      title="标签信息详情"
      :width="960"
      :visible="visible"
      :maskClosable="true"
      :destroyOnClose="true"
      @cancel="cancel()"
      :footer="null">
    <template slot="footer">
    </template>

    <table class="fx-form-view">
      <col width="220px"/>
      <col/>
      <tr>
        <th>标签名称</th>
        <td>
          {{ trip.tagName }}
        </td>
      </tr>
      <tr>
        <th>抽取优先级</th>
        <td>
          {{ trip.extractPriorityFlagText }} &nbsp;
        </td>
      </tr>
      <tr>
        <th>颜色数值代码</th>
        <td>
          {{ trip.tagColor }}
        </td>
      </tr>
      <tr>
        <th>标签颜色效果</th>
        <td>
          <a-tag :color="trip.tagColor">{{trip.tagName}}</a-tag>
        </td>
      </tr>
      <tr>
        <th>标签描述</th>
        <td>
          {{ trip.tagDetail }}
        </td>
      </tr>
    </table>
  </a-modal>
</template>

<script>
import { GetTagInfo } from '@/epp/expertmain/experttag/api/TagApi'

export default {
  name: 'TagDetailModal',
  components: {

  },
  created () {

  },
  data () {
    return {
      visible: false,
      loading: false,
      trip: {}
    }
  },
  methods: {
    onStartLoadData (id) {
      this.visible = true
      this.loadData(id)
    },
    cancel () {
      this.visible = false
    },
    async loadData (id) {
      try {
        let res = await GetTagInfo({ id: id })
        if (200 !== res.code) {
          this.$message.error('获取标签信息失败')
          return
        }
        this.trip = res.result
      } catch (e) {
        this.$message.error(e.message)
      }
    },
  }
}
</script>

<style scoped>

</style>
